import { BreadcrumbsMap } from '../../components/breadcrumbs';

export const groupsBreadcrumbs: BreadcrumbsMap = {
  '/groups': 'Groups',
};
